import { ApplyingBonusEffects } from './applying-bonus.effect';
import { CheckoutAnalyticsEffects } from './checkout-analytics.effects';
import { CheckoutInitEffects } from './checkout-init.effect';
import { CheckoutReInitEffects } from './checkout-re-init.effect';
import { CustomCheckoutEffects } from './checkout.effect';
import { MyShopEffects } from './my-shop.effect';
import { OptionsEffects } from './options.effect';
import { OrderConfirmationEffects } from './order-confirmation.effects';
import { PaymentEffects } from './payment.effect';
import { ReceiptTypeEffects } from './receipt-type.effect';
import { SavedDeliveryAddressEffects } from './saved-delivery-address.effect';
import { ShopsEffects } from './shops.effect';
import { TimeSlotsEffects } from './time-slots.effect';
import { UserPickupShopsEffects } from './user-pickup-shops.effect';

export const effects: any[] = [
  CheckoutInitEffects,
  ReceiptTypeEffects,
  CustomCheckoutEffects,
  SavedDeliveryAddressEffects,
  PaymentEffects,
  TimeSlotsEffects,
  OptionsEffects,
  ShopsEffects,
  UserPickupShopsEffects,
  MyShopEffects,
  CheckoutAnalyticsEffects,
  OrderConfirmationEffects,
  ApplyingBonusEffects,
  CheckoutReInitEffects,
];
